import * as Yup from 'yup'
import { Form, Col, Row } from 'react-bootstrap'
import { CustomFormControl, } from '../../../../StyledComponents';
import { checkRequiredText } from '../ValidationRules';
import { CustomFormSelect } from '../../../../StyledComponents';
import { Options } from '../SelectOptions';

export const Schema = (settings) => Yup.object().shape({
    street: checkRequiredText(settings),
    postalCode: checkRequiredText(settings),
    city: checkRequiredText(settings),
});

export const PersonalDataSubForm = ({ form: { values, handleBlur, handleChange, touched, errors }, ...props }) => {
    const { colors, settings } = props;
    return (
        <>
            
                <Form.Group className="mb-3" controlId="formStreet">
                    <Form.Label>Straße*</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Straße eingeben"
                        type="text"
                        name="street"
                        value={values.street}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.street && !errors.street}
                        isInvalid={touched.street && errors.street}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.street}
                    </Form.Control.Feedback>
                </Form.Group>
                <Row className="mb-3">
                <Form.Group as={Col}controlId="formPostalCode">
                    <Form.Label>PLZ*</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Postleitzahl eingeben"
                        type="text"
                        name="postalCode"
                        value={values.postalCode}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.postalCode && !errors.postalCode}
                        isInvalid={touched.postalCode && errors.postalCode}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.postalCode}
                    </Form.Control.Feedback>
                </Form.Group>

                <Form.Group as={Col} controlId="formCity">
                    <Form.Label>Ort*</Form.Label>
                    <CustomFormControl
                        colors={colors}
                        placeholder="Ort eingeben"
                        type="text"
                        name="city"
                        value={values.city}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        isValid={touched.city && !errors.city}
                        isInvalid={touched.city && errors.city}
                        maxLength={settings.textInputLimit}
                    />
                    <Form.Control.Feedback type="invalid">
                        {errors.city}
                    </Form.Control.Feedback>
                </Form.Group>
                </Row>
                <Form.Group className="mb-3" controlId="formhandicap">
                    <Form.Label>Schwerbehinderung</Form.Label>
                    <CustomFormSelect
                        colors={colors}
                        name="handicap"
                        value={values.handicap}
                        isValid={touched.handicap && !errors.handicap}
                        isInvalid={touched.handicap && errors.handicap}
                        onChange={handleChange}
                        onBlur={handleBlur}
                    >
                        <option value="">Bitte auswählen...</option>
                        {Options.Handicap.map((item, index) => <option key={index} value={item.value}>{item.text}</option>)}
                    </CustomFormSelect>
                    <Form.Control.Feedback type="invalid">
                        {errors.handicap}
                    </Form.Control.Feedback>
                </Form.Group>
        </>
    );
};